import { Component, OnInit, ElementRef } from '@angular/core';
import { NavController, IonContent, IonList, IonItem, IonIcon, IonLabel, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonAvatar, IonNote } from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { AuthService, MenuService, AgencyService, LoggedUserService, NavigationService, SynchroService, AlertModalService } from '@app/services';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [
        IonContent, IonList, IonItem, IonIcon, IonLabel, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonAvatar, IonNote, TranslatePipe
    ]
})
export class MenuComponent implements OnInit {

    agencyData = this.agencyService.getAgencyConfigData();
    isOpen: boolean = false;
    isReduced: boolean = false;
    forceReduce: boolean = false;
    nbAlerts: number = 7;
           
    constructor(
        private elRef: ElementRef,
        private navController: NavController,
        public translateService: TranslateService,
        private authService : AuthService,
        public menuService: MenuService,
        private agencyService: AgencyService,
        public loggedUserService: LoggedUserService,
        public navigationService: NavigationService,
        public synchroService: SynchroService,
        private alertModalService: AlertModalService
    ) {  }

    ngOnInit() {
        this.checkSizeWindow();
        window.addEventListener("resize", () => this.checkSizeWindow());
        window.addEventListener("popstate", () => this.checkOpenMenu());
    }
    
    ngOnDestroy() {
        window.removeEventListener("resize", () => this.checkSizeWindow());
        window.removeEventListener("popstate", () => this.checkOpenMenu());
    }
    
    checkSizeWindow(){
        if(window.innerWidth < 1280){
            if(!this.elRef.nativeElement.parentElement?.classList.contains('reduce_menu')){
                this.reduceMenu();
                this.forceReduce = true;
            }
        }
        else if(this.forceReduce){
            this.extendMenu();
        }
    }
    
    checkOpenMenu(){
        if(this.isOpen){
            this.closeMenu();
        }
    }
    
    openMenu(){        
        this.elRef.nativeElement.parentElement?.classList.add('open_menu');
        this.isOpen = true;
    }
    
    closeMenu(){
        this.elRef.nativeElement.parentElement?.classList.remove('open_menu');
        this.isOpen = false;
    }
    
    reduceMenu(){
        this.elRef.nativeElement.parentElement?.classList.add('reduce_menu');
        this.isReduced = true;
    }
    
    extendMenu(){
        this.elRef.nativeElement.parentElement?.classList.remove('reduce_menu');
        this.isReduced = false;
        this.forceReduce = false;
    }
    
    getInitials(){
        let str = '';    
        let loggedUser = this.loggedUserService.loggedUser;
        if(loggedUser){
            if(loggedUser.firstName && loggedUser.firstName != ''){
                str += loggedUser.firstName.charAt(0);
            }
            if(loggedUser.lastName && loggedUser.lastName != ''){
                str += loggedUser.lastName.charAt(0);
            }   
            if(str === '' && loggedUser.login){
                str = loggedUser.login.charAt(0);
            }    
        }
        return str;
    }
    
    getDateSynchro(): string {
        return moment(this.synchroService.dateSynchro).format("DD/MM/YYYY HH:mm:ss");
    }
    
    goToHome(){
        this.navController.navigateRoot('/');
    }
    
    goToPage(route: string){
        this.closeMenu();
        this.navController.navigateRoot(route);
    }
    
    showAlerts(){
        this.alertModalService.show();
    }
    
    logoutOut(){
        this.closeMenu();        
        this.navController.navigateRoot('logout');
    }    
    
    goBack() {
        this.closeMenu();
        this.navigationService.back();
    }
    
}
